import { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/state/store';
import { loadCurrentSRSCards, submitSRSAnswer } from '@/state/features/app';
import styles from './styles.module.scss';

interface SRSCardsProps {}

export default function SRSCards({}: SRSCardsProps) {
    const dispatch = useAppDispatch();
    const cards = useAppSelector((state) => state.app.currentSRSCards) || [];
    const [flippedCards, setFlippedCards] = useState<Set<string>>(new Set());

    useEffect(() => {
        dispatch(loadCurrentSRSCards());
    }, [dispatch]);

    const handleCardTap = (cardId: string) => {
        setFlippedCards((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(cardId)) {
                newSet.delete(cardId);
            } else {
                newSet.add(cardId);
            }
            return newSet;
        });
    };

    const handleAnswer = (cardId: string, quality: 'hard' | 'easy' | 'very easy') => {
        const qualityMap = {
            hard: 1,
            easy: 3,
            'very easy': 4,
        };

        dispatch(
            submitSRSAnswer({
                card_id: cardId,
                quality: qualityMap[quality],
            }),
        );

        setFlippedCards((prev) => {
            const newSet = new Set(prev);
            newSet.delete(cardId);
            return newSet;
        });
    };

    if (cards.length === 0) {
        return null;
    }

    const displayCards = cards.slice(0, 5);

    return (
        <div className={styles.SRSCards}>
            {displayCards.map((card) => (
                <div key={card.id} className={styles.Card} onClick={() => handleCardTap(card.id)}>
                    <div className={styles.CardContent}>
                        <a
                            className={styles.extLLMLink}
                            rel="noopener noreferrer"
                            target="_blank"
                            href={`https://claude.ai/new?q=${encodeURIComponent(
                                'Explain the following JPLT japanese grammar point: ' +
                                    (card.front || '') +
                                    ' ' +
                                    (card.back || '') +
                                    '\n Provide a brief explanation and example sentences in Japanese. Use kanji with furigana in brackets, as well as an English translation for the examples.',
                            )}`}
                        >
                            CL
                        </a>
                        <div className={styles.CardFront}>{card.front}</div>
                        {flippedCards.has(card.id) && <div className={styles.CardBack}>{card.back}</div>}
                    </div>
                    <div className={styles.CardButtons}>
                        <button
                            className={styles.AnswerButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAnswer(card.id, 'easy');
                            }}
                        >
                            Easy
                        </button>
                        <button
                            className={styles.AnswerButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAnswer(card.id, 'hard');
                            }}
                        >
                            Hard
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}
